import { RouteConfig } from "vue-router";

const bancos: RouteConfig = {
  path: "/bancos",
  name: "bancos",
  component: () => import(/* webpackChunkName: "bancos" */ "@/views/Bancos.vue"),
};

export default bancos;
